module.exports = __webpack_public_path__ + "img/minus.ba68e98e.svg";